export default "__VITE_ASSET__948c48fe__"